import Relation from './relation';
export default Relation;